export default {
	export: 'Ekspordi riski raport',
	title: 'Raporti pealkiri',
	includeInRaport: 'Lisa raportile juurde',
	description: 'Raporti kirjeldus',
	includeTitlePage: 'Tiitelleht',
	detailedRisks: 'Detailne raport',
	includeOverview: 'Riskide ülevaate sektsioon',
	generate: 'Genereeri | Genereeritakse',
	riskReport: 'Riskihalduse aruanne',
	includeDescription: 'Riski kirjeldus',
	includeImpactedAssets: 'Mõjutatud varad',
	includeThreats: 'Ohud',
	includeVulnerabilities: 'Nõrkused',
	includeMitigationMeasures: 'Leevendusmeetmed',
	includeRiskMatrix: 'Riskimaatriks',
}
